import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/links'
import { CustomerDocument } from 'pages/EmbeddedCustomers/helpers/types'
import { WithPaginationApiResponse } from 'types/pagination'

const CUSTOMER_DOCUMENTS_API_URL = '/platform/v1/customers/documents'

export const getCustomerDocuments = (
  customerReference: string
): Promise<WithPaginationApiResponse<CustomerDocument[]>> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: CUSTOMER_DOCUMENTS_API_URL,
    method: 'GET',
    params: { customerReference },
  })
}
export const getCustomerDocumentLink = (reference: string): Promise<string> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `${CUSTOMER_DOCUMENTS_API_URL}/${reference}/url`,
    method: 'GET',
  })
}
